import isEmpty from 'lodash.isempty';
import { PROFICIENT_LEVEL } from '../shared/TrcInterpretationMapper';
import { INTERP } from '../shared/CommonConstants';

const { WELL_BELOW_PROFICIENT, BELOW_PROFICIENT, PROFICIENT, ABOVE_PROFICIENT } = PROFICIENT_LEVEL;

export const COMMON_PROFICIENT_MAPPER = {
    [WELL_BELOW_PROFICIENT]: 'Well Below',
    [BELOW_PROFICIENT]: 'Below',
    [PROFICIENT]: 'Proficient',
    [ABOVE_PROFICIENT]: 'Above',
};

export const COMMON_PROFICIENT_SCORE_MAPPER = {
    [WELL_BELOW_PROFICIENT]: 'Well Below Proficient',
    [BELOW_PROFICIENT]: 'Below Proficient',
    [PROFICIENT]: 'Proficient',
    [ABOVE_PROFICIENT]: 'Above Proficient',
};

export const PROFICIENT_LEVEL_MAPPER = {
    [PROFICIENT_LEVEL.BELOW_PROFICIENT]: INTERP.BELOW,
    [PROFICIENT_LEVEL.PROFICIENT]: INTERP.PROFICIENT,
};

export const getCommonProficientLevel = (proficientLevel, mapper) =>
    isEmpty(proficientLevel) ? null : mapper[proficientLevel.toLowerCase()];
